import moment from 'moment'
import React from 'react'
import {
  Bar,
  CartesianGrid,
  ComposedChart,
  Label,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import LegendComponent from '../../../common/legend/Legend'
import { i18n } from '../../index'
import css from './thumbsUp.css'
import type { MonthlyThumbsUpReport } from './types'
type Props = {
  month: moment.Moment
  data: Array<MonthlyThumbsUpReport>
}
const STROKES = {
  ACTUAL: '#78A22F',
  TARGET: '#F7AC01',
}

class ThumbsUpGraph extends React.Component<Props> {
  render() {
    const { month, data } = this.props
    return (
      <div>
        <h4>
          {i18n.t('reporting.thumbsUp')}: {moment(month).format('MMMM YYYY')}
        </h4>
        <div className={css.chart}>
          <div>
            <ResponsiveContainer width='100%' height={300}>
              <ComposedChart
                margin={{
                  top: 30,
                  right: 10,
                  bottom: 10,
                  left: 10,
                }}
                data={data}
              >
                <CartesianGrid />

                <XAxis
                  dataKey={'date'}
                  interval={0}
                  tickFormatter={(item) => moment(item).format('D')}
                  axisLine={{
                    stroke: '#ccc',
                    strokeWidth: 1,
                  }}
                  tickSize={0}
                  tickMargin={10}
                  tick={{
                    fontSize: 12,
                  }}
                />
                <YAxis
                  padding={{
                    top: 0,
                  }}
                  axisLine={{
                    stroke: '#ccc',
                    strokeWidth: 1,
                  }}
                  tickCount={6}
                  tickSize={0}
                  tickMargin={10}
                  tick={{
                    fontSize: 12,
                  }}
                >
                  <Label value='kpl' position='top' offset={15} />
                </YAxis>

                <Tooltip />

                <Legend content={<LegendComponent />} />

                <Line
                  type='linear'
                  dataKey='target'
                  dot={false}
                  unit=' kpl'
                  name={i18n.t('reporting.target')}
                  legendType='line'
                  strokeWidth={3}
                  stroke={STROKES.TARGET}
                />

                <Bar
                  dataKey='actual'
                  unit=' kpl'
                  name={i18n.t('reporting.actual')?.toString()}
                  barSize={10}
                  fill={STROKES.ACTUAL}
                />
              </ComposedChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    )
  }
}

export default ThumbsUpGraph
